import styled from 'styled-components';
import { Form } from 'react-bootstrap';
import theme from '@raptormaps/theme';

export const AlertContainer = styled.div.attrs(() => ({
  className: 'AlertContainer',
}))`
  background: ${theme.colors.yellow_300};
  padding: 20px 15px;
  display: flex;
  align-items: center;
  border: solid 1px ${theme.colors.neutral_800};
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;

  p {
    margin: 0;
    font-weight: 600;
  }
`;

export const FormLabel = styled(Form.Label).attrs(() => ({
  className: 'FormLabel',
}))`
  font-weight: 500;
  color: ${({ required }) => {
    if (required) {
      return theme.colors.red_500;
    } else {
      return theme.colors.neutral_900;
    }
  }};
`;
